import { Button, FormControl, Input, Stack, VStack } from "@chakra-ui/react";
import { useAuthInMutation } from "apis";
import { ActionBar, InputLabel, Layout, PageMotion, PoweredBy } from "components";
import { add } from "date-fns";
import { useForm } from "hooks";
import useAuthToken from "hooks/useAuthToken";
import { PageProps } from "interfaces";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "hooks";
import ls from "utils/secureStorage";
import configs from "config";

export interface CheckoutProps extends PageProps {
  isPartner?: boolean;
}

export function Checkout({ isPartner }: CheckoutProps) {
  const navigate = useNavigate();
  const { authToken } = useAuthToken();

  const [authIn, { isLoading }] = useAuthInMutation();
  const { email: globalEmail, setEmail } = useForm();

  const [email, set] = useState<string | null>(null);

  const partnerEmail = useSearchParams("email");
  const persistedMail = ls.get("email");

  const partnerKey = useSearchParams("accessKey");
  const persistedPartnerKey = ls.get(configs.ACCESS_KEY) as string;

  useEffect(() => {
    if (authToken && !isPartner) {
      navigate("/verification", { replace: true });
    }

    if (
      (authToken && isPartner && partnerEmail === persistedMail) ||
      (authToken && isPartner && partnerKey === persistedPartnerKey)
    ) {
      navigate("/kyc-status?type=partner", { replace: true });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPartner]);

  const remember = useMemo(() => ls.get("remember"), []);
  const handleContinue = async (e: any) => {
    e.preventDefault();

    if (!!email) {
      try {
        const result = await authIn({ email, remember: Boolean(remember) }).unwrap();

        console.log(result, "THE RESULT");

        ls.set("tmp_cd", add(new Date(), { seconds: result.nextRequestInSecs }).toISOString());
        ls.set("email", email);
        setEmail(email);

        if (!!result && !isPartner) {
          navigate("/verification", { replace: true });
        } else {
          navigate("/verification?type=partner", { replace: true });
        }
      } catch (error: any) {
        if (error?.data?.data?.label === "CODE_ALREADY_SENT" && error?.status === 412 && !isPartner) {
          navigate("/verification", { replace: true });
        }

        if (error?.data?.data?.label === "CODE_ALREADY_SENT" && error?.status === 412 && isPartner) {
          navigate("/verification?type=partner", { replace: true });
        }
      }
    }
  };

  const emailPattern = useMemo(() => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/i, []);
  const isEmailValidFn = useCallback((email: string) => !!email && RegExp(emailPattern).test(email), [emailPattern]);
  const isEmailValid = useMemo(() => !!email && isEmailValidFn(email), [email, isEmailValidFn]);

  useEffect(() => {
    if (!!globalEmail) set(globalEmail);
    //eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   if (!quoteRes) navigate("/", { replace: true });
  // }, [quoteRes, navigate]);

  if (authToken && !isPartner) return null;

  return (
    <PageMotion key="Checkout" px="4px" minH={{ base: "96vh", md: "98vh" }}>
      <Layout>
        <ActionBar onBackClick={() => navigate(-1)} showLogo title="Checkout with Bitmama">
          The fastest and safest way to checkout on hundreds of crypto apps. Trusted by 10M+ people.
        </ActionBar>

        <Stack as="form" my="34px !important" px="3px" onSubmit={handleContinue}>
          <FormControl>
            <InputLabel htmlFor="email">Email</InputLabel>
            <Input
              isRequired
              type="email"
              id="email"
              value={email ?? partnerEmail}
              onChange={(e) => set(e.target.value)}
              placeholder="johndoe@example.com"
              defaultValue={partnerEmail}
            />
          </FormControl>

          <VStack mt="40px !important">
            <Button
              minW={{ base: "auto", "2sm": "400px" }}
              type="submit"
              w="100%"
              isDisabled={!isEmailValid || isLoading}
              isLoading={isLoading}
              _hover={{
                _disabled: {
                  opacity: 0.3,
                },
              }}
            >
              Continue
            </Button>
          </VStack>
        </Stack>
      </Layout>

      <PoweredBy />
    </PageMotion>
  );
}
